<template>
  <div>
    <QList>
      <QItem v-if="orderVerification">
        <QItemSection side class="side-icon"
          ><img src="/assets/icons/order-verification.svg" :style="convertColourComputed ? convertColourComputed : ''"
        /></QItemSection>
        <QItemSection
          ><div>
            <!--  Order Verification -->
            Review Quote
            <span v-if="docusignStatus === 'completed'">
              <i
                class="uiw-font-arrow-ios-down"
                style="display: inline; position: absolute; margin-left: 20px; top: 9px; cursor: pointer"
                v-if="!openViewQuote"
                @click="toggleViewQuote"
              />
              <i
                class="uiw-font-arrow-ios-up"
                style="display: inline; position: absolute; margin-left: 20px; top: 9px; cursor: pointer"
                v-else
                @click="toggleViewQuote"
              />
            </span>
          </div>
        </QItemSection>
        <QItemSection side>
          <ProgressListItem :text="getProgressText(orderVerification)" :status="orderVerification"></ProgressListItem>
        </QItemSection>
      </QItem>
      <QItem v-if="orderVerification && openViewQuote">
        <QItemSection side class="side-icon"></QItemSection>
        <QItemSection v-if="isWetSignature"
          ><div>
            <i class="uiw-font-eye" style="display: inline; position: absolute; top: 9px" />
            <div style="padding-left: 30px">
              <span style="cursor: pointer; color: var(--primary-color)" @click="onClickGetQuotePDF"
                >View Quote <QSpinner size="xs" color="grey-7" v-if="loadingViewQuote"
              /></span>
            </div>
          </div>
        </QItemSection>
        <QItemSection v-else
          ><div>
            <i class="uiw-font-eye" style="display: inline; position: absolute; top: 9px" />
            <div style="padding-left: 30px">
              <span style="cursor: pointer; color: var(--primary-color)" @click="onClickGetQuoteDocusign">View Quote</span>
            </div>
          </div>
        </QItemSection>
      </QItem>
      <QItem v-if="businessDetails">
        <QItemSection side class="side-icon"
          ><img src="/assets/icons/business-details.svg" :style="convertColourComputed ? convertColourComputed : ''"
        /></QItemSection>
        <QItemSection>
          <!-- Company Details -->
          Business Details & Credit Application</QItemSection
        >
        <QItemSection side>
          <ProgressListItem :text="getProgressText(businessDetails)" :status="businessDetails"></ProgressListItem>
        </QItemSection>
      </QItem>
      <QItem v-if="isUserSecondaryApplicant && docusignStatus === 'completed'">
        <QItemSection side class="side-icon"><i class="uiw-font-eye" /></QItemSection>
        <QItemSection v-if="isWetSignature">
          <span style="cursor: pointer; color: var(--primary-color)" @click="onClickGetQuotePDF">
            <QSpinner size="xs" color="grey-7" v-if="loadingViewQuote" /> View Quote
          </span></QItemSection
        >
        <QItemSection v-else
          ><span style="cursor: pointer; color: var(--primary-color)" @click="onClickGetQuoteDocusign">View Quote</span></QItemSection
        >
      </QItem>
      <QItem>
        <QItemSection side class="side-icon"
          ><img src="/assets/icons/approvals.svg" :style="convertColourComputed ? convertColourComputed : ''"
        /></QItemSection>

        <!-- old -->
        <!-- <QItemSection>{{ isUserSecondaryApplicant && isWetSignature ? 'Identity Verification' : 'ID Check & Application Review' }}</QItemSection> -->

        <!-- new -->
        <QItemSection>{{ isUserSecondaryApplicant ? 'ID Check' : 'ID Check & Application Review' }} </QItemSection>

        <!-- <QItemSection>{{
          isUserSecondaryApplicant && isWetSignature
            ? 'Identity Verification'
            : 'Approvals'
        }}</QItemSection> -->

        <img
          src="/assets/icons/small-info.svg"
          alt="Identification verification and credit application are required as part of this step."
          title="Identification verification and credit application are required as part of this step."
          :style="convertColourComputed ? convertColourComputed : ''"
          style="cursor: pointer; vertical-align: middle; margin: 0 -5px 0 0"
          @click="openDialog()"
        />
        <QItemSection side>
          <ProgressListItem :text="getProgressText(approvals)" :status="approvals"></ProgressListItem>
        </QItemSection>
      </QItem>
      <QItem v-if="reviewSignContrct">
        <QItemSection side class="side-icon"
          ><img src="/assets/icons/review-sign-contract.svg" :style="convertColourComputed ? convertColourComputed : ''"
        /></QItemSection>
        <QItemSection>
          <!-- Review & Sign Lease  -->
          Review & Sign Lease Documents</QItemSection
        >
        <QItemSection side>
          <ProgressListItem :text="getProgressText(reviewSignContrct)" :status="reviewSignContrct"></ProgressListItem>
        </QItemSection>
      </QItem>
    </QList>
    <QDialog v-model="showDocusign" full-width full-height>
      <QCard>
        <iframe :src="docusignUrl" style="width: 100%; height: calc(100% - 60px)" v-if="docusignUrl"></iframe>
        <div v-else class="flex justify-center items-center q-pa-md" style="width: 100%; height: calc(100% - 60px)">
          <QSpinner size="md" color="grey-7" />
        </div>
        <div class="text-center">
          <QBtn color="primary" no-caps @click="onCancel()" id="cancelButtonId">Cancel</QBtn>
          <QBtn color="primary" no-caps @click="onCancel()" id="nextPageButtonId" style="display: none">Next Page</QBtn>
        </div>
      </QCard>
    </QDialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ProgressListItem from '../Atoms/ProgressListItem';
import { QList, QItem, QItemSection, QDialog, QCard, QSpinner, QBtn } from 'quasar';
import MutateGetQuoteDocusign from '../../graphql/mutations/MutateGetQuoteDocusign';
import MutateGetQuotePDF from '../../graphql/mutations/MutateGetQuotePDF';
import { GLOBAL_ERROR } from '../../components/GlobalError/GlobalError';
import { GlobalDialog } from '../../components/Dialogs/GlobalDialog';
import WetSignatureMixins from '../../mixins/WetSignatureMixins.js';
import ColoureMixins from '../../mixins/ColourMixins.js';
/**
 * This component represents common UI for displaying the status in the progress list
 */
export default {
  name: 'ProgressList',
  mixins: [WetSignatureMixins, ColoureMixins],
  props: {
    orderVerification: String,
    businessDetails: String,
    approvals: String,
    reviewSignContrct: String
  },
  methods: {
    getProgressText: function (status) {
      switch (status) {
        case 'completed':
          return 'Completed';
        case 'progress':
          return 'In Progress';
        case 'pending':
          return 'Pending';
      }
    },
    toggleViewQuote: function () {
      this.openViewQuote = !this.openViewQuote;
    },
    onClickGetQuotePDF: async function () {
      this.loadingViewQuote = true;

      await this.$apollo
        .mutate({
          mutation: MutateGetQuotePDF
        })
        .then((data) => {
          let self = this;
          setTimeout(function () {
            self.downloadFileWSMix(data.data.getQuotePDF.url, 'quote.pdf');
          });
          this.loadingViewQuote = false;
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
      this.loadingViewQuote = false;
    },
    onClickGetQuoteDocusign: async function () {
      this.showDocusign = true;
      return await this.$apollo
        .mutate({
          mutation: MutateGetQuoteDocusign
        })
        .then((data) => {
          this.docusignUrl = data.data.getQuoteDocusign.url;
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
    },
    openDialog: function () {
      this.$euiNotifications.emit({
        notification: GlobalDialog,
        noEscDismiss: true,
        persistent: true,
        body: this.isUserSecondaryApplicant
          ? '<span style="color:white">Identity verification is required as part of this step.</span>'
          : '<span style="color:white">Identification verification and credit application are required as part of this step.</span>',
        qCardStyle: {
          padding: '0',
          width: '400px',
          maxWidth: '80vw',
          backgroundColor: 'var(--primary-color)'
        },
        closeBtnStyle: {
          color: 'white'
        }
      });
    },
    onCancel: function () {
      this.showDocusign = false;
      this.docusignUrl = null;
    }
  },
  data: function () {
    return {
      openViewQuote: false,
      showDocusign: false,
      loadingViewQuote: false,
      docusignUrl: null
    };
  },
  computed: {
    ...mapGetters({
      isUserSecondaryApplicant: 'vehicleApplication/isUserSecondaryApplicant',
      isWetSignature: 'vehicleApplication/isWetSignature'
    }),
    ...mapState({
      scoreboard: (state) =>
        state.vehicleApplication?.vehicleApplication?.scoreboard ? state.vehicleApplication?.vehicleApplication?.scoreboard : null
    }),
    convertColourComputed() {
      return this.convertColour();
    },
    docusignStatus() {
      return this.scoreboard?.docusignStatus ? this.scoreboard?.docusignStatus : null;
    }
  },
  components: {
    QList,
    QItem,
    QItemSection,
    ProgressListItem,
    QDialog,
    QCard,
    QSpinner,
    QBtn
  }
};
</script>

<style lang="sass" scoped>
.q-list
  font-size: 12px;
.q-item
  padding: 5px 0;
  min-height: 42px;
.side-icon
  width: 30px;
i
  color: var(--primary-color);
</style>
